import { Component } from '@angular/core'
import { SharedModule } from '@src/app/shared/shared.module.js'
import { StarRatingComponent } from '../star-rating/star-rating.component.js'

@Component({
  selector: 'app-reviews',
  templateUrl: './reviews.component.html',
  styleUrls: ['./reviews.component.scss'],
  imports: [SharedModule, StarRatingComponent],
})
export class ReviewsComponent {}
